import React from "react";
import Money from "components/money";
import OkendoStarRating from "components/okendo/star-rating";
import ProductImages from "components/product/images";
import { trackSelectItem } from "analytics";
import { useCustomer } from "hooks/useStore";
import Link from "components/link";
import getProductUrl from "utils/product-url";
import { useSettings } from "hooks/useStore";
import HighlightMatch from "components/highlight-match";

const ProductItem = ({ product, index, query }) => {
	const { toggleSearch, toggleMenu, isSearchOpen, isMenuOpen } =
		useSettings(["toggleSearch", "toggleMenu", "isSearchOpen", "isMenuOpen"]);
	const customer = useCustomer();
	const { title, type } = product;

	const handleProductClick = (event) => {
		event.stopPropagation();
		trackSelectItem({ ...product, index }, customer);
		if (isSearchOpen) toggleSearch();
		if (isMenuOpen) toggleMenu();
	};

	const showType =
		!product.title.toLowerCase().includes(query.toLowerCase()) &&
		product.type.toLowerCase().includes(query.toLowerCase());

	const productType = type.toLowerCase();

	return (
		<>
			<Link
				to={getProductUrl(product)}
				onClick={handleProductClick}
				onKeyDown={(e) => e.key === "Enter" && handleProductClick(e)}
				className="w-5/12 md:max-w-60 xl:w-60 hidden md:flex flex-1 t-search-product-click group/card search-product-t59"
				tabIndex={0}
				aria-label={`View ${title}`}
			>
				<div className="hidden md:flex flex-col gap-2.5 product-details-t59">
					<ProductImages product={product} />
					<div className="w-full">
						<div className="flex justify-between lg:gap-4 product-data">
							<h5 className="text-start line-clamp-2 text-xs md:text-lg mb-auto py-0.5">
								{title}
							</h5>
							<div className="flex flex-col justify-end min-w-fit items-end">
								<OkendoStarRating reviewAggregate={product?.reviewAggregate} className="hidden lg:flex" />
								<div className="flex items-center justify-end">
									<p className="font-semibold ml-2 text-sm hidden lg:flex">
										<Money value={product.minVariantPrice} markets={product.variant?.markets} />
									</p>
								</div>
							</div>
						</div>
						<div className="hidden flex-col justify-around h-full product-data-t59">
							<div>
								<OkendoStarRating reviewAggregate={product?.reviewAggregate} className="hidden md:flex" starsWidth="w-16"/>
								<h5 className="text-start line-clamp-2 text-xs md:text-base mb-auto py-0.5">
									{title}
								</h5>
								<p className="text-darkGray text-xs font-semibold capitalize">{productType}</p>
							</div>
							<p className="font-semibold text-xs hidden md:flex">
								<Money value={product.minVariantPrice} markets={product.variant?.markets} />
							</p>
						</div>
					</div>
				</div>
			</Link>
			<Link to={getProductUrl(product)} onClick={handleProductClick}
				className="text-base font-base font-normal md:hidden flex items-center gap-2 flex-wrap search-suggestions-v1">
				<span>
					<HighlightMatch text={title} query={query} />
				</span>
			</Link>
			<Link to={getProductUrl(product)} onClick={handleProductClick}
				className="text-base font-base font-normal md:hidden flex items-center gap-2 flex-wrap search-suggestions-v2">
				<span>
					<HighlightMatch text={title} query={query} />
				</span>
				{showType && query && <span className="text-xs text-gray-500">
					<HighlightMatch text={type} query={query} />
				</span>}
			</Link>
		</>
	);
};

export default ProductItem;
